/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_INTERFACE_LIST,
  FETCH_INTERFACE_LIST_SUCCESS,
  FETCH_INTERFACE_LIST_FAILURE,
  FETCH_INTERFACE_LIST_ADD_SUCCESS,
  FETCH_INTERFACE_LIST_ADD_FAILURE,
  FETCH_METRIC_LIST,
  FETCH_METRIC_LIST_SUCCESS,
  FETCH_METRIC_LIST_FAILURE,
  CHANGE_INTERFACES_COUNT,
} from "./actionTypes";

const interfacesReducer = (
  state = {
    isFetchingInterfaces: false,
    didInvalidateInterfaceCall: false,
    interfaceData: {},
    interfaceListData: {},
    interfacesError: "",
    isFetchingMetric: false,
    didInvalidateMetricCall: false,
    metricData: {},
    metricsError: "",
    interfacesCount: 0,
  },
  action
) => {
  switch (action.type) {
    case FETCH_INTERFACE_LIST:
      return Object.assign({}, state, {
        isFetchingInterfaces: true,
        didInvalidateInterfaceCall: false,
      });
    case FETCH_INTERFACE_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetchingInterfaces: false,
        didInvalidateInterfaceCall: false,
        interfaceData: action.data,
      });
    case FETCH_INTERFACE_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetchingInterfaces: false,
        didInvalidateInterfaceCall: true,
        interfacesError: action.errorMessage,
      });
    case FETCH_INTERFACE_LIST_ADD_SUCCESS:
      return Object.assign({}, state, {
        isFetchingInterfaces: false,
        didInvalidateInterfaceCall: false,
        interfaceListData: action.data,
      });
    case FETCH_INTERFACE_LIST_ADD_FAILURE:
      return Object.assign({}, state, {
        isFetchingInterfaces: false,
        didInvalidateInterfaceCall: true,
        interfacesError: action.errorMessage,
      });
    case FETCH_METRIC_LIST:
      return Object.assign({}, state, {
        isFetchingMetric: true,
        didInvalidateMetricCall: false,
      });
    case FETCH_METRIC_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetchingMetric: false,
        didInvalidateMetricCall: false,
        metricData: action.data,
      });
    case FETCH_METRIC_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetchingMetric: false,
        didInvalidateMetricCall: true,
        metricsError: action.errorMessage,
      });
      case CHANGE_INTERFACES_COUNT:
      return {...state, interfacesCount: action.interfacesCount};
    default:
      return state;
  }
};

export default interfacesReducer;
